import { extractProductId, getProductData } from "../shop/templates/partials";
import store from "../shop/store";
import { isBundle } from "./bundles";
var getStokedInfo = function getStokedInfo() {
  var _STOKED$GTM$includeTa, _STOKED, _STOKED$GTM, _STOKED$siteName, _STOKED2;
  return {
    includeTax: (_STOKED$GTM$includeTa = (_STOKED = STOKED) === null || _STOKED === void 0 ? void 0 : (_STOKED$GTM = _STOKED.GTM) === null || _STOKED$GTM === void 0 ? void 0 : _STOKED$GTM.includeTax) !== null && _STOKED$GTM$includeTa !== void 0 ? _STOKED$GTM$includeTa : false,
    siteName: (_STOKED$siteName = (_STOKED2 = STOKED) === null || _STOKED2 === void 0 ? void 0 : _STOKED2.siteName) !== null && _STOKED$siteName !== void 0 ? _STOKED$siteName : '',
    formatProductId: function formatProductId(item) {
      var _STOKED$GTM$formatPro, _STOKED3, _STOKED3$GTM, _STOKED4, _STOKED4$GTM, _STOKED5, _STOKED5$GTM;
      return (_STOKED$GTM$formatPro = (_STOKED3 = STOKED) === null || _STOKED3 === void 0 ? void 0 : (_STOKED3$GTM = _STOKED3.GTM) === null || _STOKED3$GTM === void 0 ? void 0 : _STOKED3$GTM.formatProductId(item, (_STOKED4 = STOKED) === null || _STOKED4 === void 0 ? void 0 : (_STOKED4$GTM = _STOKED4.GTM) === null || _STOKED4$GTM === void 0 ? void 0 : _STOKED4$GTM.siteId, (_STOKED5 = STOKED) === null || _STOKED5 === void 0 ? void 0 : (_STOKED5$GTM = _STOKED5.GTM) === null || _STOKED5$GTM === void 0 ? void 0 : _STOKED5$GTM.country)) !== null && _STOKED$GTM$formatPro !== void 0 ? _STOKED$GTM$formatPro : '';
    }
  };
};

// Check if added item already exist in cart, if so, get product line
var checkCartItemDetails = function checkCartItemDetails(itemId) {
  var _store$getState, _selection$items, _match$line;
  var sections = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = (_store$getState = store.getState()) !== null && _store$getState !== void 0 ? _store$getState : {},
    selection = _ref.selection;
  var items = (_selection$items = selection === null || selection === void 0 ? void 0 : selection.items) !== null && _selection$items !== void 0 ? _selection$items : [];
  var isSameBundle = function isSameBundle() {
    var bundleA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var bundleB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var a = bundleA.map(function (_ref2) {
      var item = _ref2.item;
      return item;
    }).join(',');
    var b = bundleB.map(function (_ref3) {
      var item = _ref3.item;
      return item;
    }).join(',');
    return a === b;
  };
  var match = items.find(function (cartItem) {
    if (cartItem.bundle) {
      return cartItem.item === itemId && isSameBundle(cartItem.bundle, sections);
    }
    return cartItem.item === itemId;
  });
  return {
    line: (_match$line = match === null || match === void 0 ? void 0 : match.line) !== null && _match$line !== void 0 ? _match$line : null,
    isLatestItemInSelection: !Boolean(match === null || match === void 0 ? void 0 : match.line)
  };
};
var formatProductData = function formatProductData(product, item, cache) {
  var _item$size, _cache$categories;
  var stoked = getStokedInfo();
  var formattedId = stoked.formatProductId(item);
  var variantName = cache.variantName || item.variant || '';
  product.dimension1 = "".concat(formattedId.slice(0, formattedId.lastIndexOf("-")), "-s");
  product.dimension2 = cache.variantSku, product.dimension3 = "".concat(item.sku, "-").concat(variantName === null || variantName === void 0 ? void 0 : variantName.toUpperCase(), "-").concat((_item$size = item.size) === null || _item$size === void 0 ? void 0 : _item$size.replace(' ', '').toUpperCase());
  product.category = cache.categoryName || (((_cache$categories = cache.categories) === null || _cache$categories === void 0 ? void 0 : _cache$categories.length) > 0 ? cache.categories[0] : product.category), product.id = cache.variantSku || product.id;
  delete product.productId;
  return product;
};
var formatProductDataForBundle = function formatProductDataForBundle() {
  var bundleSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var stoked = getStokedInfo();
  var products = [];
  bundleSections.forEach(function (item) {
    var _item$brand, _ref4, _cache$variantName;
    if (!item) return;
    var productId = item.product;
    var cache = productId ? getProductData(productId) : {};
    var formattedId = stoked.formatProductId(item);
    var baseProduct = {
      name: item.name,
      id: item.sku,
      price: stoked.includeTax ? item.priceEachAsNumber : item.priceEachWithoutTaxAsNumber,
      brand: (_item$brand = item.brand) !== null && _item$brand !== void 0 ? _item$brand : stoked.siteName,
      category: item.category,
      variant: (_ref4 = (_cache$variantName = cache.variantName) !== null && _cache$variantName !== void 0 ? _cache$variantName : item.variant) !== null && _ref4 !== void 0 ? _ref4 : '',
      quantity: item.quantity,
      productId: formattedId
    };
    products.push(formatProductData(baseProduct, item, cache));
  });
  return products;
};
var updateEcommerceWithProducts = function updateEcommerceWithProducts(data, key, products) {
  if (products.length > 0) {
    data.ecommerce[key].products = products;
  }
  return data;
};
var trackAddToCart = function trackAddToCart(data, item) {
  if (isBundle(item)) {
    return updateEcommerceWithProducts(data, 'add', formatProductDataForBundle(item.bundle));
  }

  // Regular products
  var productId = extractProductId(item);
  var cache = productId ? getProductData(productId) : {};
  var product = data.ecommerce.add.products[0];
  data.ecommerce.add.products[0] = formatProductData(product, item, cache);
  return data;
};
var trackRemoveFromCart = function trackRemoveFromCart(data, item) {
  if (isBundle(item)) {
    return updateEcommerceWithProducts(data, 'remove', formatProductDataForBundle(item.bundle));
  }

  // Regular products
  var productId = extractProductId(item);
  var cache = productId ? getProductData(productId) : {};
  var product = data.ecommerce.remove.products[0];
  data.ecommerce.remove.products[0] = formatProductData(product, item, cache);
  return data;
};
var trackPurchase = function trackPurchase(data, selection) {
  var stoked = getStokedInfo();
  var products = [];
  if (selection.items.length > 0) {
    var _formatProductData = function _formatProductData(item) {
      var _ref5, _cache$variantName2, _cache$categories2;
      var formattedId = stoked.formatProductId(item);
      var productId = extractProductId(item);
      var cache = productId ? getProductData(productId) : {};
      var variant = (_ref5 = (_cache$variantName2 = cache.variantName) !== null && _cache$variantName2 !== void 0 ? _cache$variantName2 : item.variant) !== null && _ref5 !== void 0 ? _ref5 : '';
      return {
        name: item.name,
        price: stoked.includeTax ? item.priceEachAsNumber : item.priceEachWithoutTaxAsNumber,
        brand: item.brand || stoked.siteName,
        id: item.sku,
        variant: variant,
        category: (cache === null || cache === void 0 ? void 0 : cache.categoryName) || ((cache === null || cache === void 0 ? void 0 : (_cache$categories2 = cache.categories) === null || _cache$categories2 === void 0 ? void 0 : _cache$categories2.length) > 0 ? cache === null || cache === void 0 ? void 0 : cache.categories[0] : item.category),
        quantity: item.quantity,
        dimension1: formattedId.slice(0, formattedId.lastIndexOf("-")) + '-s',
        dimension2: cache.variantSku,
        dimension3: item.sku + "-" + variant.toUpperCase() + "-" + item.size.replace(' ', '').toUpperCase()
      };
    };
    selection.items.forEach(function (item) {
      if (item !== null && item !== void 0 && item.bundle) {
        item.bundle.forEach(function (bundleItem) {
          products.push(_formatProductData(bundleItem));
        });
      } else {
        products.push(_formatProductData(item));
      }
    });
    data.ecommerce.purchase.products = products;
  }
  var paymentInfoCache = JSON.parse(localStorage.getItem('paymentInfo'));
  var addressDetails = window.tokens.debug ? paymentInfoCache : selection;
  if ((addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address) != undefined) {
    data.ecommerce.purchase.user = {
      firstname: (addressDetails.address.firstName || '').toLowerCase(),
      lastname: (addressDetails.address.lastName || '').toLowerCase(),
      email: addressDetails.address.email || '',
      phone: (addressDetails.address.phoneNumber || '').replace(/[^0-9]/g, ''),
      city: (addressDetails.address.city || '').toLowerCase(),
      country: (addressDetails.address.country || '').toLowerCase(),
      zip: (addressDetails.address.zipCode || '').replace(/[\s]/g, '')
    };
  }
  return data;
};
export { trackAddToCart, trackRemoveFromCart, trackPurchase, checkCartItemDetails };


// WEBPACK FOOTER //
// ./scripts/components/stoked.js